import { BlIcon } from 'shared-react';
import { combineStyles, fonts, media, mixins } from 'consumer-components';
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';

import { horizontalPadding, mediumViewHorizontalPadding, smallViewTopPadding } from '../Common/PaneLayout/paneStyles';
import { Link } from 'react-router';
import * as deploymentConfig from 'login-utils/deploymentConfig';
import States from 'login-constants/states';
import withUserStateCookie from './withUserStateCookie';
import * as userUtils from 'login-utils/userUtils';
import * as featureFlags from 'login-utils/featureFlags';

const loginActionColor = deploymentConfig.getOrganizationColors().action;
const translateKeyframes = {
  '0%': {
    opacity: 0,
    transform: 'translateX(-10px)',
  },
  '100%': {
    opacity: 1,
    transform: 'translateX(0)',
  },
};

const linkStyles = StyleSheet.create({
  forwardArrow: {
    display: 'none',
    [media.largeView]: {
      color: loginActionColor,
      display: 'inline-block',
      marginLeft: 12,
      transform: 'translateX(0px)',
      transition: 'transform .15s ease-out',
    },
  },
  linkWrapper: combineStyles(
    mixins.animate(translateKeyframes, 0.3, 'initial', 'initial'),
    mixins.margin(72, horizontalPadding, 0),
    mixins.transition('background-color', 0.3, 'ease-out'),
    {
      ...fonts.Roboto,
      alignItems: 'center',
      animationDelay: '.5s',
      animationFillMode: 'forwards',
      color: loginActionColor,
      display: 'flex',
      float: 'left',
      fontSize: 14,
      fontWeight: fonts.weight.medium,
      lineHeight: '18px',
      opacity: 0,
      position: 'relative',
      textDecoration: 'none',
      /*
       * Aphrodite child selector hack
       * https://github.com/Khan/aphrodite/issues/10
       */
      ':hover .animateRight': {
        transform: 'translateX(4px)',
      },
      [media.mediumView]: {
        ...mixins.margin(72, mediumViewHorizontalPadding, 0),
      },
      [media.smallView]: {
        float: 'none',
        lineHeight: '18px',
        marginTop: smallViewTopPadding,
        maxWidth: 520,
        position: 'static',
      },
    },
  ),
});

export const LoginLink = ({ userStateUrl }) => {
  const userLoggedIn = featureFlags.isEnabled('applicationChooserInDropdownMenu20190109') && userUtils.getCurrentUser();
  return userLoggedIn ? null : (
    <Link to={`/${userStateUrl}`} className={css(linkStyles.linkWrapper)}>
      Already started an application? We'll help you pick up where you left off
      <div className={`${css(linkStyles.forwardArrow)} animateRight`}>
        <BlIcon icon="date-arrow-right" size="xs" />
      </div>
    </Link>
  );
};

export default withUserStateCookie(LoginLink)({
  provisional: States.REQUEST_RESET_PASSWORD,
  full: States.LOGIN,
});
